import styled, { css } from "styled-components/native";
import { light_black } from "../../StyleHelpers";
import useGenericContentStore from "../../store/genericContent.store";

export const StyledGallery = styled.View<{ isNarrow?: boolean }>`
	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			align-items: flex-start;
			align-content: flex-start;
			gap: 1rem;
			align-self: stretch;
			flex-wrap: wrap;
		`}
	background-color: ${light_black};
	width: 100%;
	height: 100%;
	z-index: -1;
`;

// @ts-ignore
const GalleryContainer = ({ children }) => {
	const isNarrow = useGenericContentStore((state) => state.isNarrow);
	return (
		// @ts-ignores
		<StyledGallery isNarrow={isNarrow}>{children}</StyledGallery>
	);
};

export default GalleryContainer;
